import { Box } from 'theme-ui'
import { ContactOption } from 'types'
import { EmailInput, PhoneNumberInput } from './'

type ContactOptionInputProps = {
  email?: {
    name?: string
    label?: string
    value?: string
    error?: string
  }
  phone?: {
    name?: string
    label?: string
    value?: string
    error?: string
  }
  onUpdateContact: (contact: Partial<ContactOption>) => void
  disabled?: boolean
  phoneError?: string
  emailError?: string
  countryCode?: string
  tabIndex?: number
  onBlur?: () => void
}

const defaultEmailProps = {
  name: 'email',
  label: 'Contact email',
}

const defaultPhoneProps = {
  name: 'phone',
  label: 'Mobile phone',
}

export const ContactOptionInput = ({
  email,
  phone,
  onUpdateContact,
  disabled,
  countryCode,
  tabIndex,
  onBlur,
}: ContactOptionInputProps) => {
  const emailProps = { ...defaultEmailProps, ...email }
  const phoneProps = { ...defaultPhoneProps, ...phone }
  const updateContact = (name: 'phone' | 'email', value: string) => {
    onUpdateContact({ phone: phone?.value, email: email?.value, [name]: value })
  }
  return (
    <>
      <Box>
        <EmailInput
          name={emailProps.name}
          label={emailProps.label}
          value={emailProps.value}
          setFieldValue={(name, value) => updateContact('email', value)}
          disabled={disabled}
          error={emailProps.error}
          tabIndex={tabIndex}
          onBlur={onBlur}
        />
      </Box>
      <Box>
        <PhoneNumberInput
          name={phoneProps.name}
          label={phoneProps.label}
          value={phoneProps.value}
          setFieldValue={(name, value) => updateContact('phone', value)}
          disabled={disabled}
          error={phoneProps.error}
          countryCode={countryCode}
          tabIndex={tabIndex ? tabIndex + 0.1 : undefined}
          onBlur={onBlur}
        />
      </Box>
    </>
  )
}
